import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/eluma-logo.svg'
import _imports_1 from '@/assets/eluma-text.svg'


const _hoisted_1 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_2 = { class: "p-4 text-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "pt-4 pr-2 pb-0 pl-2" }
const _hoisted_5 = { class: "grid pb-2" }
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 0,
  class: "grid pb-4 fadein animation-duration-500"
}
const _hoisted_9 = { class: "col p-4 p-message-error border-round-md" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = {
  key: 1,
  class: "grid pb-4 fadein animation-duration-500"
}
const _hoisted_13 = { class: "col p-4 p-message-success border-round-md" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_18 = {
  key: 1,
  class: "field p-1 col"
}
const _hoisted_19 = { class: "grid" }
const _hoisted_20 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_21 = {
  key: 1,
  class: "field p-1 col"
}
const _hoisted_22 = { class: "grid" }
const _hoisted_23 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_24 = {
  key: 1,
  class: "field p-1 col"
}
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_27 = { class: "grid" }
const _hoisted_28 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_29 = {
  key: 1,
  class: "field p-1 col"
}
const _hoisted_30 = { class: "grid" }
const _hoisted_31 = {
  key: 0,
  class: "field p-1 col"
}
const _hoisted_32 = {
  key: 1,
  class: "field p-1 col"
}
const _hoisted_33 = { class: "grid" }
const _hoisted_34 = {
  key: 0,
  class: "field p-1 pb-0 col"
}
const _hoisted_35 = {
  key: 1,
  class: "field col"
}
const _hoisted_36 = { class: "py-4 pt-5 pl-5" }
const _hoisted_37 = {
  key: 0,
  class: "flex justify-content-end pb-2 pl-2 pr-2"
}

import { onBeforeMount, ref, toRefs } from 'vue';
import InputMask from 'primevue/inputmask';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useRouting } from '@/composables';
import { ReferralBuilderService } from '@/services';
import { ReferralBuilderSettingsInterface, ReferralBuilderProcessPayloadInterface } from '@/types';

interface PropsInterface {
  referralFormId?: string;
  isPreview?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationReferralBuilderIntakeForm',
  props: {
    referralFormId: { default: '' },
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { referralFormId } = toRefs(props);

const $routing = useRouting();

const loading = ref(true);

let v$ = useVuelidate();

const data = ref({
  student_id: '',
  student_first_name: '',
  student_last_name: '',
  building_campus: '',
  grade: '',
  referral_reason_id: '',
  referrer_title: '',
  referrer_first_name: '',
  referrer_last_name: '',
  referrer_email: '',
  referrer_phone: '',
  referral_code: '',
  referral_form_id: '',
  send_email: false,
});

const referralBuilderSettings = ref();

const referralReasons = ref([]);

const grades = ref([]);

const organization = ref(null);

const requestError = ref('');

const processingErrors = ref();

const processingSuccess = ref();

onBeforeMount(() => init());

const init = async () => {
  defineReferralFormId();

  if (data.value.referral_form_id?.length) {
    await ReferralBuilderService.getReferralBuilderSettingsByCode(data.value.referral_form_id.toString())
      .then((response) => {
        const settings = response.data.data.referral_settings;
        organization.value = response.data.data.organization_name;
        defineSettings(settings);
        referralReasons.value = response.data.data.referral_reasons;
        grades.value = response.data.data.grades;
        defineValidation(settings);
        loading.value = false;
      })
      .catch((error) => {
        requestError.value = error.data.message;
        loading.value = false;
      });
  }
};

const defineReferralFormId = () => {
  // eslint-disable-next-line
  // @ts-ignore
  data.value.referral_form_id = referralFormId.value?.length
    ? referralFormId.value.toString()
    : $routing.route.query.code;
};

const defineSettings = async (settings: ReferralBuilderSettingsInterface[]) => {
  referralBuilderSettings.value = new Map();
  settings.forEach((values: ReferralBuilderSettingsInterface) => referralBuilderSettings.value.set(values.id, values));
};

const defineValidation = async (settings: ReferralBuilderSettingsInterface[]) => {
  const rules = {};

  settings.forEach((item: ReferralBuilderSettingsInterface) => {
    const ignore = ['organization'];

    if (!ignore.includes(item.id)) {
      // eslint-disable-next-line
      // @ts-ignore
      rules[item.id] = item.required.enabled ? { required } : { required: false };
    }
  });

  v$ = useVuelidate(rules, data);
};

const toInclude = (id: string) => referralBuilderSettings.value.get(id).include.enabled;

const isRequired = (id: string) => ({ required: referralBuilderSettings.value.get(id).required.enabled });

const onClear = () => {
  data.value = {
    student_id: '',
    student_first_name: '',
    student_last_name: '',
    building_campus: '',
    grade: '',
    referral_reason_id: '',
    referrer_title: '',
    referrer_first_name: '',
    referrer_last_name: '',
    referrer_email: '',
    referrer_phone: '',
    referral_code: '',
    send_email: false,
  };
  v$.value.$reset();
  defineReferralFormId();
};

const onSubmit = async () => {
  if (!(await v$.value.$validate())) return;

  const payload: ReferralBuilderProcessPayloadInterface = data.value;
  processingSuccess.value = '';
  processingErrors.value = '';

  ReferralBuilderService.processReferralIntake(payload)
    .then((response) => {
      processingSuccess.value = response.data.message;
    })
    .catch((error) => {
      if (!error.data?.errors) {
        processingErrors.value = error.data.message;
      } else {
        const errorMessages: string[] = [];
        const errorValues = Object.values(error.data.errors);
        errorValues.forEach((items) => items.forEach((item: string) => errorMessages.push(item)));
        processingErrors.value = errorMessages;
      }
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (requestError.value.length)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "m-auto w-auto border-4 border-primary-100 bg-gray-50"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", {
                    class: "font-semibold text-primary text-lg",
                    textContent: _toDisplayString(requestError.value)
                  }, null, 8, _hoisted_3)
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              class: "m-auto w-auto border-4 border-primary-100 bg-gray-50"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (toInclude('organization'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("h1", {
                            class: "pt-2 pb-2 font-semibold text-2xl",
                            textContent: _toDisplayString(organization.value)
                          }, null, 8, _hoisted_7)
                        ]))
                      : _createCommentVNode("", true),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-fixed" }, [
                      _createElementVNode("div", { class: "grid" }, [
                        _createElementVNode("div", { class: "col-fixed" }, [
                          _createElementVNode("img", {
                            alt: "eLuma logo",
                            height: "36",
                            src: _imports_0
                          })
                        ]),
                        _createElementVNode("div", { class: "col-fixed" }, [
                          _createElementVNode("img", {
                            alt: "eLuma logo",
                            height: "20",
                            class: "mt-2",
                            src: _imports_1
                          })
                        ])
                      ])
                    ], -1))
                  ]),
                  (processingErrors.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          (typeof processingErrors.value === 'string')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                textContent: _toDisplayString(processingErrors.value)
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "mb-3" }, "Please correct the following errors.", -1)),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processingErrors.value, (error, key) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: key,
                                      class: "pb-1",
                                      textContent: _toDisplayString(error)
                                    }, null, 8, _hoisted_11))
                                  }), 128))
                                ])
                              ], 64))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (processingSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("h3", {
                            textContent: _toDisplayString(processingSuccess.value)
                          }, null, 8, _hoisted_14)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (toInclude('student_id'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('student_id')),
                                  for: "student_id"
                                }, "SSID", 2),
                                _createVNode(_component_InputText, {
                                  id: "student_id",
                                  modelValue: _unref(v$).student_id.$model,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).student_id.$model) = $event)),
                                  type: "text",
                                  placeholder: "SSID",
                                  class: _normalizeClass(["w-full", { 'w-full': true, 'p-invalid': _unref(v$).student_id.$error }]),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('building_campus'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('building_campus')),
                                  for: "building_campus"
                                }, " District/School/Campus/Building ", 2),
                                _createVNode(_component_InputText, {
                                  id: "building_campus",
                                  modelValue: _unref(v$).building_campus.$model,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).building_campus.$model) = $event)),
                                  type: "text",
                                  placeholder: "District/School/Campus/Building",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).building_campus.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          (toInclude('student_first_name'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('student_first_name')),
                                  for: "student_first_name"
                                }, "First Name", 2),
                                _createVNode(_component_InputText, {
                                  id: "student_first_name",
                                  modelValue: _unref(v$).student_first_name.$model,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).student_first_name.$model) = $event)),
                                  type: "text",
                                  placeholder: "First Name",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).student_first_name.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('student_last_name'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('student_last_name')),
                                  for: "student_last_name"
                                }, "Last Name", 2),
                                _createVNode(_component_InputText, {
                                  id: "student_last_name",
                                  modelValue: _unref(v$).student_last_name.$model,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).student_last_name.$model) = $event)),
                                  type: "text",
                                  placeholder: "Last Name",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).student_last_name.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (toInclude('grade'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('grade')),
                                  for: "grade"
                                }, "Grade", 2),
                                _createVNode(_component_Dropdown, {
                                  id: "grade",
                                  modelValue: _unref(v$).grade.$model,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).grade.$model) = $event)),
                                  options: grades.value,
                                  placeholder: "Select Grade",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).grade.$error })
                                }, null, 8, ["modelValue", "options", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('referral_reason_id'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referral_reason_id')),
                                  for: "referral_reason_id"
                                }, "Reason", 2),
                                _createVNode(_component_Dropdown, {
                                  id: "referral_reason_id",
                                  modelValue: _unref(v$).referral_reason_id.$model,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).referral_reason_id.$model) = $event)),
                                  options: referralReasons.value,
                                  "option-label": "title",
                                  "option-value": "id",
                                  placeholder: "Select Reason",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referral_reason_id.$error })
                                }, null, 8, ["modelValue", "options", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mt-3 mb-5 border-top-3 border-gray-200" }, null, -1)),
                        _createElementVNode("div", _hoisted_25, [
                          (toInclude('referrer_title'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referrer_title')),
                                  for: "referrer_title"
                                }, " Referrer Title/Relationship to Referral ", 2),
                                _createVNode(_component_InputText, {
                                  id: "referrer_title",
                                  modelValue: _unref(v$).referrer_title.$model,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).referrer_title.$model) = $event)),
                                  type: "text",
                                  placeholder: "Referrer Title/Relationship to Referral",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referrer_title.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (toInclude('referrer_first_name'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referrer_first_name')),
                                  for: "referrer_first_name"
                                }, "Referrer First Name", 2),
                                _createVNode(_component_InputText, {
                                  id: "referrer_first_name",
                                  modelValue: _unref(v$).referrer_first_name.$model,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).referrer_first_name.$model) = $event)),
                                  type: "text",
                                  placeholder: "Referrer First Name",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referrer_first_name.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('referrer_last_name'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referrer_last_name')),
                                  for: "referrer_last_name"
                                }, "Referrer Last Name", 2),
                                _createVNode(_component_InputText, {
                                  id: "referrer_last_name",
                                  modelValue: _unref(v$).referrer_last_name.$model,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).referrer_last_name.$model) = $event)),
                                  type: "text",
                                  placeholder: "Referrer Last Name",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referrer_last_name.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (toInclude('referrer_email'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referrer_email')),
                                  for: "referrer_email"
                                }, "Referrer Email", 2),
                                _createVNode(_component_InputText, {
                                  id: "referrer_email",
                                  modelValue: _unref(v$).referrer_email.$model,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).referrer_email.$model) = $event)),
                                  type: "text",
                                  placeholder: "Referrer Email",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referrer_email.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('referrer_phone'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referrer_phone')),
                                  for: "referrer_phone"
                                }, "Referrer Phone", 2),
                                _createVNode(_unref(InputMask), {
                                  id: "referrer_phone",
                                  modelValue: _unref(v$).referrer_phone.$model,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).referrer_phone.$model) = $event)),
                                  mask: "(999) 999-9999",
                                  placeholder: "(999) 999-9999",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referrer_phone.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mt-3 mb-5 border-top-3 border-gray-200" }, null, -1)),
                        _createElementVNode("div", _hoisted_33, [
                          (toInclude('referral_code'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(isRequired('referral_code')),
                                  for: "referral_code"
                                }, "Referral Code", 2),
                                _createVNode(_component_InputText, {
                                  id: "referral_code",
                                  modelValue: _unref(v$).referral_code.$model,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).referral_code.$model) = $event)),
                                  type: "text",
                                  placeholder: "Referral Code",
                                  class: _normalizeClass({ 'w-full': true, 'p-invalid': _unref(v$).referral_code.$error }),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (toInclude('send_email'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_Checkbox, {
                                    id: "send_email",
                                    modelValue: _unref(v$).send_email.$model,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).send_email.$model) = $event)),
                                    class: "mr-2",
                                    binary: true
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("label", {
                                    class: _normalizeClass(`font-semibold text-primary ${isRequired('send_email')}`),
                                    for: "send_email"
                                  }, " Send Confirmation Email ", 2)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                ])
              ]),
              footer: _withCtx(() => [
                (!processingSuccess.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createVNode(_component_AppButton, {
                        type: "secondary",
                        text: "Clear",
                        onClick: onClear
                      }),
                      _createVNode(_component_AppButton, {
                        type: "primary",
                        text: "Submit",
                        disabled: __props.isPreview,
                        onClick: onSubmit
                      }, null, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}
}

})